export default __webpack_public_path__ + "static/media/mar_del_plata.f95fce67.jpg";